<template>
  <div>
    <div
      class="dataset-header d-flex align-center ga-3 py-3 px-2 rounded"
      @click="expanded = !expanded">
      <v-icon
        :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        size="20"
        class="text-medium-emphasis"></v-icon>

      <div class="flex-grow-1 d-flex align-center flex-wrap ga-2">
        <span class="font-weight-bold">{{ dataset.label }}</span>
        <span class="id-badge">{{ dataset.id }}</span>
        <span class="font-size-13 text-disabled">
          {{ getSubmissionsLabel(dataset) }} · {{ getDatasetRange(dataset) }}
        </span>
      </div>

      <v-chip
        :color="statusChipColor[status]"
        rounded="pill"
        size="small"
        density="comfortable">
        <span
          class="status-dot mr-2 font-weight-bold"
          :style="{ backgroundColor: statusDotColor[status] }"></span>
        {{ getDatasetStatusLabel(dataset) }}
      </v-chip>
    </div>

    <v-expand-transition>
      <div v-show="expanded" class="px-2 pb-2">
        <div v-if="note" class="dataset-note text-medium-emphasis mb-4 mt-1">
          {{ note }}
        </div>

        <chronology-history-item
          v-for="(history, index) in dataset.history"
          :key="history.packageId + index"
          :history="history"
          :is-last="
            index === dataset.history.length - 1
          "></chronology-history-item>
      </div>
    </v-expand-transition>
  </div>
</template>

<script lang="ts">
import { computed, PropType, ref } from 'vue'
import type { ChronologyDataset } from '@/utils/types'
import ChronologyHistoryItem from './ChronologyHistoryItem.vue'
import {
  getDatasetStatus,
  getDatasetStatusLabel,
  getDatasetNote,
  getSubmissionsLabel,
  getDatasetRange,
  statusChipColor,
  statusDotColor,
} from './helpers'

export default {
  name: 'ChronologyDataset',
  components: { ChronologyHistoryItem },
  props: {
    dataset: {
      type: Object as PropType<ChronologyDataset>,
      required: true,
    },
  },
  methods: { getDatasetStatusLabel, getSubmissionsLabel, getDatasetRange },
  setup(props) {
    const expanded = ref(false)

    const status = computed(() => getDatasetStatus(props.dataset))
    const note = computed(() => getDatasetNote(props.dataset))

    return { expanded, status, note, statusChipColor, statusDotColor }
  },
}
</script>

<style scoped lang="scss">
.dataset-header {
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: rgba(var(--v-theme-on-surface), 0.04);
  }
}

.id-badge {
  font-family: monospace;
  font-size: 12px;
  background-color: rgba(var(--v-theme-on-surface), 0.06);
  border-radius: 4px;
  padding: 1px 6px;
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.dataset-note {
  background-color: rgba(var(--v-theme-on-surface), 0.04);
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
}
</style>
